import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DefaultLayoutComponent } from './layouts/default-layout/default-layout.component';
import { ManagementComponent } from './modules/shared/management/management.component';
import { MsalGuard } from '@azure/msal-angular';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full'
  },
  {
    path: '',
    component: DefaultLayoutComponent,
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full'
      },
      {
        path: 'dashboard',
        loadChildren: () => import('./modules/dashboard/dashboard.module').then(m => m.DashboardModule),
        canLoad: [MsalGuard]
      },
      {
        path: 'search',
        loadChildren: () => import('./modules/search/search.module').then(m => m.SearchModule),
        canLoad: [MsalGuard]
      },
      {
        path: 'fittings',
        loadChildren: () => import('./modules/fitting-selector/fitting-selector.module').then(m => m.FittingSelectorModule),
        canLoad: [MsalGuard]
      },
      {
        path: 'closures',
        loadChildren: () => import('./modules/closure-selector/closure-selector.module').then(m => m.ClosureSelectorModule),
        canLoad: [MsalGuard]
      },
      {
        path: 'orings',
        loadChildren: () => import('./modules/oring-selector/orings.module').then(m => m.ORingsModule),
        canLoad: [MsalGuard]
      },
      {
        path: 'pigs',
        loadChildren: () => import('./modules/pig-selector/pig-selector.module').then(m => m.PigSelectorModule),
        canLoad: [MsalGuard]
      },
      {
        path: 'pig-product-guide',
        loadChildren: () => import('./modules/pig-product-guide/pig-product-guide.module').then(m => m.PigProductGuideModule),
        canLoad: [MsalGuard]
      },
      {
        path: 'pe',
        loadChildren: () => import('./modules/pe-selector/pe-selector.module').then(m => m.PeSelectorModule),
        canLoad: [MsalGuard]
      },
      {
        path: 'pigsig',
        loadChildren: () => import('./modules/pig-sig-selector/pig-sig-selector.module').then(m => m.PigSigSelectorModule),
        canLoad: [MsalGuard]
      },
      {
        path: 'sealing-elements',
        loadChildren: () => import('./modules/sealing-elements/sealing-elements.module').then(m => m.SealingElementsModule),
        canLoad: [MsalGuard]
      },
      {
        path: 'equipment',
        loadChildren: () => import('./modules/equipment/equipment.module').then(m => m.EquipmentModule)
      },
      {
        path: 'errors',
        loadChildren: () => import('./modules/errors/errors.module').then(m => m.ErrorsModule)
      },
      {
        path: 'admin',
        loadChildren: () => import('./modules/admin/admin.module').then(m => m.AdminModule),
        canLoad: [MsalGuard]
      },
      {
        path: 'pages',
        loadChildren: () => import('./modules/pages/pages.module').then(m => m.PagesModule)
      },
      {
        path: 'user-profile',
        component: ManagementComponent,
      },
    ]
  },

  { path: '**', redirectTo: '/pages/notfound' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
